import React from 'react'
import { ErrorPanel } from 'core/component/ErrorModal'
import styled from 'styled-components'
import { prop } from 'ramda'

const Panel = styled.div`
  padding: 2em;
`

class InitError extends React.Component {
  render() {
    const props = this.props.modalInfo
    const { jwtKey } = this.props
    // console.log('jwtKey', jwtKey)
    // if (props && props.errorMsg && props.errorMsg.includes('JWT')) {
    console.log(props)
    if (
      prop &&
      props.httpStatus === 401 &&
      props.errorMsg === 'Invalid credential'
    ) {
      window.localStorage.removeItem(jwtKey)
      window.location.reload()
    }

    if (props && props.appExceptionId === 100) {
      window.localStorage.removeItem(jwtKey)
      window.location.reload()
    }
    return (
      <Panel>
        <h2>Error Initializing application</h2>
        <ErrorPanel {...this.props} />
      </Panel>
    )
  }
}

export default InitError
